import React, { useState } from 'react'

import { FSDecline, FSEndBonus, FSFooter, FSMultipleBonuses, FSSingleBonus } from '@components'

import { useFreeBuyBonusStore, useFreeSpinsBonusesStore } from '@stores'

import BSModalTemplate from '@components/BonusSystemCommon/BSModalTemplate'
import { buildGradientStyle } from '@utils/buildGradientStyle'
import { BonusSystemDeclineState, BonusSystemState } from 'game-ui-types'
import { FreeSpinsBonus } from '@amusnet/mgs-ws-client'

const FreeSpinsBonusSystem: React.FC = () => {
    const bonusSystemState = useFreeSpinsBonusesStore((state) => state.bonusSystemState)
    const bonusSystemDeclineState = useFreeSpinsBonusesStore((state) => state.bonusSystemDeclineState)
    const declinedBonusesIds = useFreeSpinsBonusesStore((state) => state.declinedBonusesIds)
    const bonuses = useFreeSpinsBonusesStore((state) => state.bonuses)
    const isModalOpened = useFreeSpinsBonusesStore((state) => state.isModalOpened)
    const setIsModalOpened = useFreeSpinsBonusesStore((state) => state.setIsModalOpened)

    const hasAwardedFreeBuyBonuses = useFreeBuyBonusStore((state) => state.hasAwardedFreeBuyBonuses)

    const [selectedBonus, setSelectedBonus] = useState<FreeSpinsBonus | undefined>()

    const isInDeclineState =
        bonusSystemDeclineState === BonusSystemDeclineState.SINGLE_BONUS_DECLINE ||
        bonusSystemDeclineState === BonusSystemDeclineState.MULTIPLE_BONUSES_DECLINE ||
        bonusSystemDeclineState === BonusSystemDeclineState.BUNDLE_DECLINE

    const gradient = buildGradientStyle(
        ['#93490B 0%', '#FEE880 40%', '#FFFBE6 49.56%', '#FEE880 60.06%', '#93490B 100%'],
        '90deg'
    )

    const renderContent = () => {
        if (isInDeclineState) {
            switch (bonusSystemDeclineState) {
                case BonusSystemDeclineState.SINGLE_BONUS_DECLINE:
                    return <FSDecline bonus={selectedBonus} />
                case BonusSystemDeclineState.BUNDLE_DECLINE:
                    return <FSDecline bonus={selectedBonus} />
                case BonusSystemDeclineState.MULTIPLE_BONUSES_DECLINE:
                    return <FSDecline />
                default:
                    return
            }
        }

        switch (bonusSystemState) {
            case BonusSystemState.SINGLE_BONUS_INITIAL:
                return <FSSingleBonus updateSelectedBonus={setSelectedBonus} />
            case BonusSystemState.MULTIPLE_BONUSES_INITIAL:
                return <FSMultipleBonuses setSelectedBonus={setSelectedBonus} />
            case BonusSystemState.END:
                return <FSEndBonus />
        }
    }

    return (
        !hasAwardedFreeBuyBonuses && (
            <BSModalTemplate
                isModalOpened={isModalOpened}
                setIsModalOpened={setIsModalOpened}
                titleKey="gameui.bonusSystem.freeSpinsTitle"
                body={renderContent()}
                footer={<FSFooter bonus={selectedBonus} />}
                titleColor="black"
                gradient={gradient}
                bonuses={bonuses}
                bonusSystemState={bonusSystemState}
                declinedBonusesIds={declinedBonusesIds}
                bonusId={selectedBonus?.id}
            />
        )
    )
}

export default FreeSpinsBonusSystem
